import React from 'react';
import { useTenant } from '../../../context/TenantContext';
import { parseEm } from '../inlineEm';
import { ShotFrame } from './Shot';
import { REVISE_ANCHORS } from './sectionMeta';

/**
 * The `outcomes` block, rendered as a numbered gallery of captures. Same content
 * shape the other themes use for outcomes — a numbered title and a paragraph —
 * with the optional `shot` carrying the capture.
 *
 * Not on the shipped page since v4: these six panels became a switcher inside
 * the Essay Labs section, where they sit next to the thing they describe rather
 * than a screen away from it. Kept registered so a tenant can put the gallery
 * back, but it carries NO default copy any more — if this renders, every word
 * came from `branding.marketing.outcomes`.
 */
export const ReviseReportGallery: React.FC = () => {
  const { tenant } = useTenant();
  const marketing = tenant?.branding.marketing;
  const items = marketing?.outcomes ?? [];
  if (items.length === 0) return null;

  const heading = marketing?.copy?.outcomesHeading || '';
  const lede = marketing?.copy?.outcomesSubhead;

  return (
    <section className="rv-sec" id={REVISE_ANCHORS.outcomes} data-accent="essay">
      <div className="rv-wrap">
        <div className="rv-head">
          {heading && <h2>{parseEm(heading)}</h2>}
          {lede && <p className="rv-lede">{lede}</p>}
        </div>

        <div className="rv-gallery">
          {items.map((item, i) => (
            <div className="rv-item" key={item.title}>
              {item.shot && (
                <div className="rv-figure">
                  <ShotFrame shot={item.shot} />
                </div>
              )}
              <div className="rv-hd">
                <span className="rv-n">{String(i + 1).padStart(2, '0')}</span>
                <h3>{item.title}</h3>
              </div>
              {item.body && <p>{item.body}</p>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
